export enum AccountStatus {
    Active = 0,
    NotConfirmed,
    Blocked
}